import { isEmpty } from 'lodash';

export function formatPhoneNumber(phoneNumberString: string) {
  const cleaned = ('' + phoneNumberString).replace(/\D/g, '').replace('+', '');
  const match = cleaned.match(/^(\d{1,3})?(\d{3})(\d{3})(\d{4})$/);
  if (match) {
    const countryCode = match[1] ? `+${match[1]}` : '';
    return `${countryCode}(${match[2]}) ${match[3]}-${match[4]}`;
  }
  return '--';
}

function pad(value: number) {
  return value < 10 ? '0' + value : value;
}

export function utcOffset() {
  const date = new Date();
  const sign = date.getTimezoneOffset() > 0 ? '-' : '+';
  const offset = Math.abs(date.getTimezoneOffset());
  const hours = pad(Math.floor(offset / 60));
  const minutes = pad(offset % 60);
  return sign + hours + ':' + minutes;
}

export function toTitleCase(str: string) {
  return str
    .split('-')
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');
}

export function padClaimNumber(claimNumber: string | number): string {
  const claimString = String(claimNumber).trim();
  if (isEmpty(claimString)) return '';
  const numStr = String(claimString);
  return numStr.padStart(12, '0');
}
